module.exports = __webpack_public_path__ + "img/zomaron-logo.9008a438.svg";